module.exports = __webpack_public_path__ + "static/media/compare_connect_banner.cda225a5.png";